<template>
  <div @submit.prevent="verify">
    <vs-row>
      <div class="flex items-end px-3 mt-4">
        <feather-icon svgClasses="w-6 h-6" icon="ShieldIcon" class="mr-2 c-primary" />
        <span class="font-medium text-lg leading-none">Consenso Trattamento dei Dati</span>
      </div>
      <vs-divider />
    </vs-row>
    <vs-row class="mb-6">
      <vs-row class="md:w-12/12 w-full px-2">
        <ul class="demo-alignment">
          <li class="m-0 mr-4"><vs-checkbox icon-pack="feather" icon="icon-thumbs-up" color="success" :disabled="is_readonly" v-model="form.privacy_b1" name="privacy_b1">Autorizzo al trattamento dei dati personali</vs-checkbox></li>
          <li class="m-0 mr-4"><vs-checkbox icon-pack="feather" icon="icon-thumbs-up" color="success" :disabled="is_readonly" v-model="form.autocertificazione" name="autocertificazione">Accetto le condizioni generali</vs-checkbox></li>
          <li class="m-0"><vs-button @click="generatePDF" color="warning" type="line" icon-pack="feather" icon="icon-download">Consulta le condizioni generali</vs-button></li>
        </ul>
      </vs-row>
    </vs-row>
    <vs-row>
      <div class="flex items-end px-3 mt-4">
        <feather-icon svgClasses="w-6 h-6" icon="Share2Icon" class="mr-2 c-primary" />
        <span class="font-medium text-lg leading-none">Consenso invio delle nostre Comunicazioni</span>
      </div>
      <vs-divider />
    </vs-row>
    <vs-row class="mb-6">
      <vs-row class="md:w-12/12 w-full px-2">
        <ul class="demo-alignment">
          <li><vs-checkbox icon-pack="feather" icon="icon-map" color="success" :disabled="is_readonly" v-model="form.privacy_b2">Associative sul Territorio e sulle Federazioni</vs-checkbox></li>
          <li><vs-checkbox icon-pack="feather" icon="icon-paperclip" color="success" :disabled="is_readonly" v-model="form.privacy_b3">Relative ai nostri Servizi</vs-checkbox></li>
          <li><vs-checkbox icon-pack="feather" icon="icon-shopping-cart" color="success" :disabled="is_readonly" v-model="form.privacy_b4">Commerciali su Convenzioni e Promozioni</vs-checkbox></li>
          <li><vs-checkbox icon-pack="feather" icon="icon-users" color="success" :disabled="is_readonly" v-model="form.privacy_b5">Trattamento Titolare Effettivo servizi</vs-checkbox></li>
        </ul>
      </vs-row>
    </vs-row>
  </div>
</template>

<script>
export default {
  props: ['form','is_readonly'],
  components: {
  },

  data () {
    return {
      is_saving: false,
    }
  },

  computed: {
    az () {
      return this.form.azienda
    },
  },

  methods: {
    generatePDF() {
      this.activeLoading = true
      this.$vs.loading({
        type:'radius',
      })
      let p_to_print = {...this.form}
      p_to_print['data_inserimento'] = this.$tariffe.formatDateNew(p_to_print['data_inserimento'])
      p_to_print['data_inizio'] = p_to_print['data_inizio'] ? this.$tariffe.formatDateNew(p_to_print['data_inizio']) : ''
      p_to_print['data_fine'] = p_to_print['data_fine'] ? this.$tariffe.formatDateNew(p_to_print['data_fine']) : ''
      p_to_print['data_fine'] = p_to_print['data_fine'] ? this.$tariffe.formatDateNew(p_to_print['data_fine']) : ''
      p_to_print['azienda']['contatti'].forEach((el) => {
        el.contatto.data_nascita = this.$tariffe.formatDateNew(el.contatto.data_nascita)
      });

      let url = '/modulo-tirocinio/generate_autocertificazione'
      axios.post(process.env.VUE_APP_BACKEND_API+url, {
        object: p_to_print,
      },{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data], {type:'application/octet-stream'}));
        const link = document.createElement('a');
        link.href = url
        this.$vs.loading.close()
        link.setAttribute('download', response.headers['x-file-name']);
        document.body.appendChild(link);
        link.click();
      }).catch(e => {
        console.log(e)
        this.$vs.loading.close()
      })
    },
  },

  // watch: {
  //   form(v) {
  //     if (v.privacy_b1) {
  //       console.log(v.privacy_b1);
  //     } else {
  //       console.log(v.privacy_b1,'not');
  //     }
  //   },
  //   autocertificazione(v) {
  //     if (v.autocertificazione) {
  //       console.log(v.autocertificazione,'auutocert');
  //     } else {
  //       console.log('not auutocert');
  //     }
  //   }
  // }
}
</script>

<style lang="scss">
.con-input-upload .text-input {
  font-weight: normal;
  // font-style: italic;
}
</style>
